import { adminGet, adminPut } from './useAdminCore';
function getSystemStatus(onSuccess = null) {
    adminGet("/SystemStatus", onSuccess);
}
function saveSystemStatus(status, onSuccess = null, onError = null) {
    adminPut("/SystemStatus", status, onSuccess, onError);
}
function getSystemSettings(onSuccess = null) {
    adminGet("/Settings", onSuccess);
}
function saveSystemSetting(setting, onSuccess = null, onError = null) {
    adminPut("/Settings", setting, onSuccess, onError);
}
export { getSystemStatus, saveSystemStatus, getSystemSettings, saveSystemSetting };
